export default __webpack_public_path__ + "static/media/detail1.c43c9a5b.jpg";